var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Campanha de Covid")]),_vm._v(" "),_c('table',{ref:"tabela",staticClass:"size-tabela table display table-hover table-striped",attrs:{"id":"relAuster"}},[_c('thead'),_vm._v(" "),_c('tbody'),_vm._v(" "),_c('tfoot')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }